module.exports = __webpack_public_path__ + "static/media/id_clavebc_bEN.c07b3a0c.svg";